import React, { FC } from "react";
import { Heading, Text, Box, Button } from "@smile2impress/components";
import { HalfImage } from "@smile2impress/templates";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { useQueryString } from "hooks/useQueryString";

import { LeadForm } from "components/LeadForm";
import { BOOKING_FORM_ID } from "components/BookingForm/constants";
import DrSmileLogo from "components/Icons/icons/drsmile-logo.svg";
import { checkIsDrSmile } from "utils/checkIsDrSmile";

import { BookingFormProps } from "./BookingForm.types";

export const BookingForm: FC<BookingFormProps> = ({
    image,
    title,
    subtitle,
    description,
    button,
    withPromoCode = false,
    defaultTreatmentType,
}) => {
    const { locale } = useUTSLocaleContext();
    const queryString = useQueryString();

    const hasDrSmileStyle = checkIsDrSmile(locale);

    return (
        <Box
            id={BOOKING_FORM_ID}
            {...(hasDrSmileStyle && {
                bg: "#2444E6",
                px: [3, 3, 10],
                py: [5, 5, 10],
                borderRadius: "xl",
            })}
        >
            <HalfImage image={image}>
                <Box mx={[-2]}>
                    {hasDrSmileStyle && (
                        <Box mb={2} w={168} h={66}>
                            <DrSmileLogo width="100%" height="100%" />
                        </Box>
                    )}
                    <Heading
                        textStyle="title1"
                        {...(hasDrSmileStyle && {
                            mb: 3,
                            color: "text.primaryInverse",
                        })}
                        {...(subtitle && {
                            mb: 3,
                        })}
                    >
                        {title}
                    </Heading>
                    {subtitle && (
                        <Heading as="h3" textStyle="title3" mt={0}>
                            {subtitle}
                        </Heading>
                    )}
                    {description && (
                        <Text
                            mt={[2, 2, 3]}
                            {...(hasDrSmileStyle && {
                                mt: 0,
                                color: "text.primaryInverse",
                            })}
                        >
                            {description}
                        </Text>
                    )}
                    {button && (
                        <Button
                            mt={2}
                            {...button}
                            href={
                                queryString
                                    ? button?.href + queryString
                                    : button?.href
                            }
                        />
                    )}
                </Box>
                {!hasDrSmileStyle && (
                    <Box mt={[3, 3, 5]}>
                        <LeadForm
                            withPromoCode={withPromoCode}
                            defaultTreatmentType={defaultTreatmentType}
                        />
                    </Box>
                )}
            </HalfImage>
        </Box>
    );
};
